export const CAREER_SECTION_ENDPOINT = window.location.pathname.split('/')[3]

export const CAREER_PATH = {
    NEW_VACANCY: 'new-vacancy',
    MY_VACANCIES: 'my-vacancies',
    CONTACTS: 'contacts',
    APPLICANTS: 'applicants',
}